import { Flex } from '@bridebook/aura';
import { isFaqSection } from '@bridebook/web/lib/wedding-website/utils/sections-typeguards';
import { useTranslation } from 'next-i18next';
import { SectionContainer } from '@bridebook/web/components/wedding-website/view-mode/layouts-v2/components/section-container';
import {
  BodyText,
  Header2,
} from '@bridebook/web/components/wedding-website/view-mode/layouts-v2/components/typography';
import { useWeddingWebsiteData } from '@bridebook/web/components/wedding-website/view-mode/layouts-v2/data/data-context';

export const Faq = () => {
  const { t } = useTranslation('weddingWebsite');
  const { website } = useWeddingWebsiteData();

  const section = website.sections.find(isFaqSection);
  return (
    <SectionContainer detailsSectionId="faq" previewSectionId="faq">
      <Header2>{t('previewMode.tile.faq.title2')}</Header2>
      <Flex className="flex-col gap-8">
        {section?.data.map((qa) => (
          <Flex key={qa.question} className="flex-col">
            <BodyText weight="subheader">{qa.question}</BodyText>
            <BodyText>{qa.answer}</BodyText>
          </Flex>
        ))}
      </Flex>
    </SectionContainer>
  );
};
